import axios from 'axios'

import { toCamelCase } from '../lib/typeHelper'

export enum InvitationStatus {
  PENDING = 'PENDING',
  ACCEPTED = 'ACCEPTED',
  EXPIRED = 'EXPIRED',
}

export interface Invitation {
  id: string
  dateCreated: string
  dateUpdated: string
  email: string
  role: string
  status: InvitationStatus
  org: string
}

export interface InvitationDetails {
  orgName: string
  role: string
  status: InvitationStatus
}

export function sendInvitation(data: { email: string; role: string }): Promise<Invitation> {
  return axios
    .post('/api/v1/insure/invitations/send/', data)
    .then((response) => toCamelCase(response.data) as Invitation)
}

export function getInvitationDetails(id: string): Promise<InvitationDetails> {
  return axios
    .get(`/api/v1/insure/invitations/${id}/details/`)
    .then((response) => toCamelCase(response.data) as InvitationDetails)
}

export function acceptInvitation(id: string): Promise<{ message: string }> {
  return axios.post(`/api/v1/insure/invitations/${id}/accept/`).then((response) => response.data)
}

export function deactivateMember(orgUserId: string): Promise<{ message: string }> {
  return axios.post(`/api/v1/insure/invitations/${orgUserId}/deactivate/`).then((response) => response.data)
}
